import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Fullscreen, FullscreenExit } from '@mui/icons-material';
import { IWorkplaces } from 'module/workplaces/interface/WorkplacesInterface';
import { useCalendarView } from 'core/hooks/useCalendarView';
import './ScheduleEventsHeader.style.scss';

interface ScheduleEventsHeaderProps {
    workplacesData: IWorkplaces;
    workplaceId: number;
    onSwitchCalendarType?: (type: 'schedule' | 'request' | 'event') => void;
    onAddShift?: () => void;
    onPublish?: () => void;
    canManageShifts?: boolean;
    isShiftActionsEnabled?: boolean;
    isFullscreenSupported?: boolean;
    isFullscreen?: boolean;
    onToggleFullscreen?: () => void;
    headerStartContent?: React.ReactNode;
}

const ScheduleEventsHeader: React.FC<ScheduleEventsHeaderProps> = ({
    workplacesData: _workplacesData,
    workplaceId: _workplaceId,
    onSwitchCalendarType: _onSwitchCalendarType,
    onAddShift,
    onPublish,
    canManageShifts = true,
    isShiftActionsEnabled = true,
    isFullscreenSupported = false,
    isFullscreen = false,
    onToggleFullscreen,
    headerStartContent,
}) => {
    const { calendarView, setCalendarView } = useCalendarView();

    const handleAddShift = () => {
        if (onAddShift) {
            onAddShift();
        }
    };

    const handlePublish = () => {
        if (onPublish) {
            onPublish();
        }
    };

    return (
        <div className="customHeader EventsHeader schedule-events-header">
            <div className="customHeaderTop">
                <div className="headerStart">
                    {headerStartContent}
                </div>
                <div className="centerControls">
                    <div className="viewToggleContainer">
                        <button
                            className={`viewToggle ${calendarView === 'day' ? 'active' : ''}`}
                            onClick={() => setCalendarView('day')}
                        >
                            Day
                        </button>
                        <button
                            className={`viewToggle ${calendarView === 'week' ? 'active' : ''}`}
                            onClick={() => setCalendarView('week')}
                        >
                            Week
                        </button>
                    </div>
                </div>
                <div className="headerToolbar">
                    {isFullscreenSupported && onToggleFullscreen && (
                        <Tooltip
                            title={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
                            placement="left"
                            arrow
                        >
                            <IconButton
                                className="calendar-fullscreen-toggle"
                                onClick={onToggleFullscreen}
                                size="small"
                                aria-label={
                                    isFullscreen ? 'Exit fullscreen calendar' : 'Enter fullscreen calendar'
                                }
                            >
                                {isFullscreen ? (
                                    <FullscreenExit fontSize="small" />
                                ) : (
                                    <Fullscreen fontSize="small" />
                                )}
                            </IconButton>
                        </Tooltip>
                    )}
                    {canManageShifts && (
                        <button
                            className="addEventButton"
                            onClick={handleAddShift}
                            disabled={!isShiftActionsEnabled}
                            style={{
                                opacity: isShiftActionsEnabled ? 1 : 0.5,
                                cursor: isShiftActionsEnabled ? 'pointer' : 'not-allowed',
                            }}
                        >
                            Add
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ScheduleEventsHeader;
